__turbopack_context__.v({
  "ctaButton": "FPed8q_ctaButton",
  "productListItem": "FPed8q_productListItem",
});
